import { API_URL } from "config";
import Http from "util/https";
import { CSVUploadOrderCheckParam, CSVUploadOrderParam, OrderSupplierCsv, OrderSupplierCsvResponseApi, PlaceOrder } from "../types/index";
import { convertUTCToDate, orderStatusFromNumber } from "../utils/common";

// const res: {data: OrderSupplierCsvResponseApi} = {
//   data: {
//     process_id: "1234",
//     total: 0,
//     shipping_infos: [{
//       order_no: "1234567890123",
//       item_cd: "000001",
//       jan_cd: "0123456789012",
//       brand: "WH",
//       item_name: "WH STA",
//       size: "185/65R15H",
//       maker_item_cd: "-",
//       order_quantity: 1000,
//       order_status: 3,
//       unit_base_price: 10000,
//       order_date: "2025-01-01",
//       desired_date: "2025-01-01",
//       shipping_date: "2025-01-01",
//       shipping_scheduled: "2025-01-01",
//       arrival_date: "2025-01-01",
//       shipping_dest_zip: "012-3456",
//       shipping_dest_address: "埼玉県戸田市美女木北２－１－１７",
//       shipping_dest_tel: "000-0000-0000",
//       order_store_fax: "000-0000-0001",
//       shipping_dest_name: "美女木店",
//       shipping_company: "ヤマト運輸",
//       shipping_no: "012345678901",
//       memo: "店舗メモです",
//       remarks: "本部メモです",
//       error: ""
//     }],
//   }
// };

/**
 * 出荷CSV追加ローディングApi
 * @param params Apiのパラメータ
 * @returns OrderSupplierCsvResponseApi[]
 */
export default async function getCsvOrderSupplierConfirmCheckApi(params: CSVUploadOrderCheckParam) {
  const http = Http.default.alterAuth({useToken: true});
  const url = `${API_URL}/order/shipping/csv/confirm`;
  const res = await http.post<OrderSupplierCsvResponseApi>(url, params);
  console.log(res);

  const orders: OrderSupplierCsv[] = res.data.shipping_infos.map((s, i) => {
    const order: OrderSupplierCsv = {
      id: params.offset + i + 1,
      orderStatus: orderStatusFromNumber(s.order_status),
      orderNumber: s.order_no ?? '',
      productCd: s.item_cd ?? '',
      janCd: s.jan_cd ?? '',
      brand: s.brand ?? '',
      productName: s.item_name ?? '',
      size: s.size ?? '',
      productNumber: s.maker_item_cd ?? '',
      orderCount: s.order_quantity || 0,
      shippingCount: s.delivery_quantity || 0,
      headquartersCost: (s.unit_base_price * s.order_quantity) || 0,
      headquartersUnitCost: s.unit_base_price || 0,
      orderDate: convertUTCToDate(s.order_date),
      deliveryDate: convertUTCToDate(s.desired_date),
      shippingDate: convertUTCToDate(s.shipping_date),
      expectedShippingDate: convertUTCToDate(s.shipping_scheduled),
      arrivalDate: s.arrival_date,
      shopRemarks: s.memo ?? '',
      destinationName: s.shipping_dest_name ?? '',
      shippingCompanyName: s.shipping_company ?? '',
      trackingNumber: s.shipping_no ?? '',
      postalCd: s.shipping_dest_zip ?? '',
      destinationAddress: s.shipping_dest_address ?? '',
      phoneNumber: s.shipping_dest_tel ?? '',
      error: (s.errors && s.errors.length > 0) ? s.errors.join('\n') : undefined,
    };

    return order;
  });

  console.log(orders);
  return orders;
}
